<template>
  <div class="question-container">
    <div class="instructions-content" v-if="!getCurrentQuestion && currentQuestionNo === 0">
      <div class="instructions-text"><b>INSTRUCTIONS:</b></div>
      <br />
      <ul>
        <li class="instructions-text" v-for="(i, index) in getInstructions" :key="index" v-html="i"></li>
      </ul>
      <hr />
      <div class="instructions-footnote">
        To display instructions here, include 2-column rows with first column
        "Instructions". Each instruction can be a separate row.
      </div>
    </div>
    <div class="answer-content" v-if="getCurrentQuestion && showAnswer">
      <div :class="{ 'answer-text': true, 'peek-mode': peekAnswer }">
        <span class="answer-header">{{ peekAnswer ? '[ANS (PEEK MODE)]' : '[ANS]' }}</span>
        <div v-html="getAnswerHtml"></div>
      </div>
    </div>

    <div v-if="getCurrentQuestion && showAnswer" class="question-answer-separator" />
    <div :class="{
      'question-content': true,
    }" v-if="getCurrentQuestion && showQuestion">
      <div :class="{
        'question-text': true,
        'question-text-dull': ['ShowAnswer', 'Answer'].includes(
          questionDisplayMode
        ),
        'question-with-image': imageExists,
      }" v-html="getQuestionHtml"></div>
      <div class="question-image" v-if="imageExists">
        <img v-shortkey.once="[keyMap.image.imageZoom.toLowerCase()]" @shortkey="toggleImageExpand()"
          :class="{ image: true, expanded: imageExpanded }" :src="getCurrentQuestion.imageUrl"
          :alt="`Toggle Zoom (${keyMap.image.imageZoom.toUpperCase()})`"
          :title="`Toggle Zoom (${keyMap.image.imageZoom.toUpperCase()})`" @click="toggleImageExpand()" />
        <!-- <img class="image" src="https://i.imgur.com/EvYrhFo.jpeg" alt="" /> -->
        <!-- <img class="image" src="https://i.imgur.com/EvYrhFo.jpeg" alt="" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import showdown from "showdown";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "DisplayQuestion",
  data() {
    return {
      converter: new showdown.Converter(),
      dim: { width: 0, height: 0 },
      imageExpanded: false,
    };
  },
  computed: {
    ...mapState([
      "questionDisplayMode",
      "keyMap",
      "currentQuestionNo",
      "instructions",
      "peekAnswer",
    ]),
    ...mapGetters(["getCurrentQuestion"]),
    showQuestion() {
      return ["Question", "ShowAnswer", "Answer"].includes(
        this.questionDisplayMode
      );
    },
    showAnswer() {
      return this.questionDisplayMode === "Answer";
    },
    getInstructions() {
      return this.instructions.map((x) => this.convertToHtml(x));
    },
    getQuestionHtml() {
      const rawText = this.getCurrentQuestion.questionText;
      return this.convertToHtml(rawText);
    },
    getAnswerHtml() {
      const answerHtml = this.convertToHtml(this.getCurrentQuestion.answerText);
      return `${answerHtml}`;
    },
    imageExists() {
      return this.getCurrentQuestion.imageUrl;
    },
  },
  methods: {
    ...mapActions(["switchQuestionMode"]),
    convertToHtml(text) {
      //Separate function to work around not converting underscores as MarkDown
      const initText = text.replace(/_/g, "284382437724");
      const result = this.converter.makeHtml(initText);
      return result.replace(/284382437724/g, "_");
    },
    toggleImageExpand() {
      this.imageExpanded = !this.imageExpanded
    },
    clearImageExpand() {
      this.imageExpanded = false;
    }
  },
};
</script>

<style scoped>
.question-container {
  margin-top: 30px;
}

.question-content {
  margin: 0 5%;
  display: flex;
  /* height: 420px; */
}

.answer-content,
.instructions-content {
  margin: 10px 5% 0;
}

.question-text,
.answer-text,
.instructions-text {
  text-align: left;
  font-size: min(32px, 3vmin);
  flex: 3 3 60%;
}

.answer-text.peek-mode {
  background-color: rgb(56 79 107);
  color: #fdfcf6;
  padding: 0 20px;
}

.instructions-footnote {
  font-size: min(18px, 1.25vmin);
  opacity: 90%;
}

.question-with-image {
  margin-right: 20px;
}

.question-image {
  flex: 2 2 40%;
  text-align: center;
  height: 43vh;
  display: flex;
  justify-content: end;
}

.question-text-dull {
  color: #55555566;
}

.answer-header {
  font-weight: bold;
}

.image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform-origin: bottom right;
}

.image.expanded {
  transform: scale(1.75);
  transform-origin: bottom right;
}

.question-answer-separator {
  border: 1px solid #cccccc;
  margin: 30px 10%;
}

p {
  margin: 0;
}
</style>